import React from "react"
import { Grid, Link, Typography, makeStyles } from "@material-ui/core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMapMarkerAlt } from "@fortawesome/pro-light-svg-icons/faMapMarkerAlt"
import { faChevronDown } from "@fortawesome/pro-light-svg-icons/faChevronDown"
import { LocalizedStrict } from "shared/Modules/Localization/Components/Localized"

const useStyles = makeStyles((theme) => ({
    locationLine: {
        color: theme.palette.primary.main,
    },
    locationLineLinkContainer: {
        flexGrow: 1,
    },
    locationName: {
        flexShrink: 1,
        maxWidth: "calc(100% - 42px)",
    },
    locationLineMapMarker: {
        height: "1.5em",
        width: "auto !important",
        marginBottom: theme.spacing(1),
        color: theme.palette.grey[700],
    },
    overflowEllipsis: {
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
    },
}))

type Props = Readonly<{
    myLocation: string | undefined
}>

export function LocationPicker({ myLocation }: Props) {
    const classes = useStyles()

    return (
        <Grid
            container
            direction="row"
            alignItems="center"
            className={classes.locationLine}
            wrap={"nowrap"}
            spacing={1}
        >
            <Grid item>
                <FontAwesomeIcon
                    icon={faMapMarkerAlt}
                    className={classes.locationLineMapMarker}
                />
            </Grid>
            <Grid
                item
                container
                alignItems={"center"}
                justifyContent="flex-start"
                spacing={1}
                className={classes.locationLineLinkContainer}
                wrap={"nowrap"}
            >
                <Grid item className={classes.locationName}>
                    <Link
                        component={Typography}
                        variant="subtitle1"
                        underline="none"
                        className={classes.overflowEllipsis}
                    >
                        {Boolean(myLocation) ? myLocation : (
                            <LocalizedStrict id="choose-location-picker-no-location">
                                <span>Pick location</span>
                            </LocalizedStrict>
                        )}
                    </Link>
                </Grid>
                <Grid item>
                    <FontAwesomeIcon icon={faChevronDown} size={"1x"} />
                </Grid>
            </Grid>
        </Grid>
    )
}

